import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
  LoginTypes,
  useAuthService,
  useSubscriptionRef,
} from '@procom-labs/common'
import { useAlert } from '@procom-labs/molecules'

import { CommonRoutesPaths } from '@resume-portal/routes/routes.enum'

export const useVerifyEmail = (): {
  handleSendVerificationEmail: () => void
  isLoading: boolean
} => {
  const { addAlert } = useAlert()
  const { t } = useTranslation('main')
  const [isLoading, setIsLoading] = useState(false)
  const subscriptionRef = useSubscriptionRef()

  const authService = useAuthService()
  const handleSendVerificationEmail = useCallback(() => {
    setIsLoading(true)
    subscriptionRef.current = authService
      .resendEmailVerification(
        CommonRoutesPaths.Parse,
        LoginTypes.GorillaResume
      )
      .subscribe({
        complete: () => {
          setIsLoading(false)
          addAlert({
            message: t('upgradePlan.verifySuccess'),
            severity: 'success',
          })
        },
        error: () => {
          addAlert({
            severity: 'error',
            message: t('common.alert.somethingWrong'),
          })
        },
      })
  }, [addAlert, subscriptionRef, t])
  return { handleSendVerificationEmail, isLoading }
}
